import { render, staticRenderFns } from "./kc_list.vue?vue&type=template&id=4626463a&scoped=true&"
import script from "./kc_list.vue?vue&type=script&lang=js&"
export * from "./kc_list.vue?vue&type=script&lang=js&"
import style0 from "./kc_list.vue?vue&type=style&index=0&id=4626463a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626463a",
  null
  
)

export default component.exports